import makeApiClient, { Type } from '@/api/api';
import type { TOUProfile } from '../types';

export async function saveTouProfile(profile: TOUProfile[]) {
  const { sendPostRequest } = makeApiClient(Type.Core)

  const body = profile

  await sendPostRequest(`tariffs/time-of-use-config`, body)
}
